/**
 * Reglas del rango de fechas. Puro, para poder probarlo.
 *
 * EL PROBLEMA QUE ESTO RESUELVE, y por qué no es cosmético: los criterios solo incluyen
 * `rangoFechas` cuando están los DOS extremos, así que un rango a medias no daba error — se
 * interpretaba como "sin filtro de fecha", o sea TODAS las fechas.
 *
 * Con la selección de la primera prueba real (Castile-La Mancha + CERTIFICADO_MITECO), eso es la
 * diferencia entre **1 viaje y 0,40 €** y **69 viajes y 113,62 €**. En silencio, y en la dirección
 * de pagar más. Encontrado por Javi el 2026-08-11 intentando seleccionar un solo día.
 */

export type Rango = [Date | null, Date | null];

/**
 * `true` cuando hay exactamente un extremo puesto.
 *
 * No es un estado válido que signifique nada: el botón de limpiar del picker vacía los dos a la vez,
 * así que un solo extremo siempre es una selección a medio hacer. La UI lo trata como una entrada
 * incompleta y no como "sin filtro".
 */
export function rangoIncompleto(rango: Rango): boolean {
  const [desde, hasta] = rango;
  return (desde === null) !== (hasta === null);
}

/** `true` cuando el rango está completo y filtra de verdad. */
export function rangoCompleto(rango: Rango): boolean {
  return rango[0] !== null && rango[1] !== null;
}
